export default "__VITE_ASSET__CEfHXxgz__"